<template>
  <div class="apple-signin-btn wrapper-icon-open-id">
    <AppleIconSvg />
  </div>
</template>

<script>
  import AppleIconSvg from '../icons/svg/apple.vue'

  export default {
    name: 'RoundAppleIcon',
    components: {
      AppleIconSvg
    }
  }
</script>


// WEBPACK FOOTER //
// RoundApple.vue?6a5425a9